import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaRegTimesCircle } from 'react-icons/fa';

import { disconnectUser, selectImpersonated, setImpersonated, selectUser, setSelectedAccount } from '../../reducers/account.reducer';
import { resetState, setCurrentEntity, selectDirty } from '../../reducers/app.reducer';
import { resetContentfulReducer } from '../../reducers/contentful.reducer';

import { Initial } from '../initials/Initial';
import { Notifications } from '../notifications/Notifications';

import { paths } from '@routes/routes.constants';
import DropDownMenu from '../dropDownMenu/DropDownMenu';
import { UserComponentContainer, UserName, UserNameContainer } from './UserComponent.styles';
export interface AccountComponentProps {
  account: any;
}

export const UserComponent = ({ account }: AccountComponentProps) => {
  const dispatch = useDispatch<any>();

  const impersonated = useSelector(selectImpersonated);
  const user = useSelector(selectUser);
  const surveyIsDirty = useSelector(selectDirty);
  const history = useHistory();

  const disconnect = () => {
    let leaveAnyway = true;
    if (surveyIsDirty) {
      leaveAnyway = window.confirm('Vous avez des changements non sauvegardés. Etes vous sûr de vouloir quitter la page?');
    }
    if (leaveAnyway) {
      window.sessionStorage.removeItem('logged_user');
      window.sessionStorage.removeItem('access_token');
      window.localStorage.clear();
      window.sessionStorage.clear();
      dispatch(resetState());
      dispatch(resetContentfulReducer());
      dispatch(disconnectUser());
      history.push(paths.login);
    }
  };

  const handleRemoveImpersonated = () => {
    dispatch(setImpersonated(null));
    dispatch(setSelectedAccount(null));
    dispatch(setCurrentEntity(account.entities[0]));
    history.push(paths.dashboardGroup);
  };

  const getInitialOptions = () => [
    {
      label: 'Profile',
      onClick: () => history.push(paths.profile),
    },
    {
      label: 'Déconnexion',
      onClick: disconnect,
    },
  ];

  return (
    <UserComponentContainer>
      <UserName>
        {impersonated && (
          <span>
            ( <b>{user?.firstName ? user?.name + ' ' + user?.firstName : user?.name}</b> En tant que <b>{impersonated.companyName}</b>
            <FaRegTimesCircle onClick={handleRemoveImpersonated} />)
          </span>
        )}
      </UserName>

      <Notifications notificationsList={user?.notifications} />
      {history.location.pathname !== paths.admin && (
        <DropDownMenu
          title={
            <UserNameContainer>
              {user?.name?.toUpperCase()} {user?.firstName?.toUpperCase()}
            </UserNameContainer>
          }
          width={'300px'}
          options={getInitialOptions()}
          header={<Initial name={user?.name} firstName={user?.firstName} />}
        />
      )}
    </UserComponentContainer>
  );
};
